import axios from 'axios'
import { getApiUrl } from '../utils/api-utils'

const API_BASE_URL = getApiUrl()

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export const smitApi = {
  sendCode: (phone) => api.post('/sms/send', { phone }),
  verifyCode: (phone, code) => api.post('/sms/verify', { phone, code }),
}

export const ordersApi = {
  create: (data) => api.post('/orders', data),
  getAll: (status) => api.get('/orders', { params: { status } }),
  getOne: (id) => api.get(`/orders/${id}`),
  updateStatus: (id, status) => api.patch(`/orders/${id}/status`, { status }),
  delete: (id) => api.delete(`/orders/${id}`),
}

export const datesApi = {
  getAvailable: () => api.get('/dates/available'),
  getAll: () => api.get('/dates/all'),
  create: (date) => api.post('/dates', date),
  update: (id, data) => api.patch(`/dates/${id}`, data),
  delete: (id) => api.delete(`/dates/${id}`),
}

export default api
